import { ROUTES } from '../../../constants/routes';
import { normalizeFormStudioSection } from '../form-studio/utils/formStudioSections';

/**
 * Builds the business function (account) detail route.
 * @param {string} accountId
 * @param {{ name?: string, tab?: string }} [options]
 */
export function buildAccountRoute(accountId, { name = '', tab = '' } = {}) {
  if (!accountId) {
    return ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS;
  }

  const params = new URLSearchParams();
  if (name) params.set('name', name);
  if (tab) params.set('tab', tab);

  const query = params.toString();
  const base = `${ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS}/${encodeURIComponent(accountId)}`;
  return query ? `${base}?${query}` : base;
}

/**
 * Builds the business service (workspace) detail route.
 * @param {string} accountId
 * @param {string} workspaceId
 * @param {{ accountName?: string }} [options]
 */
export function buildWorkspaceRoute(accountId, workspaceId, { accountName = '' } = {}) {
  if (!accountId || !workspaceId) {
    return ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS;
  }

  const params = new URLSearchParams();
  if (accountName) params.set('accountName', accountName);

  const query = params.toString();
  const base = `${ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS}/accounts/${encodeURIComponent(accountId)}/workspaces/${encodeURIComponent(workspaceId)}`;
  return query ? `${base}?${query}` : base;
}

export function buildNewFormStudioRoute(accountId, workspaceId) {
  if (!accountId || !workspaceId) {
    return ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS;
  }

  return `${buildWorkspaceRoute(accountId, workspaceId)}/forms/new`;
}

export function buildFormStudioRoute(accountId, workspaceId, formId, section = '') {
  if (!accountId || !workspaceId || !formId) {
    return ROUTES.CAMPAIGN.BUSINESS_FUNCTIONS;
  }

  const base = `${buildWorkspaceRoute(accountId, workspaceId)}/forms/${encodeURIComponent(formId)}`;
  if (!section) {
    return base;
  }

  return `${base}/${encodeURIComponent(normalizeFormStudioSection(section))}`;
}
